import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum TransactionActionName {
    TRANSACTION_CHANGE_STATE = 'transaction_change_state',
    TRANSACTION_PROCESS_PACKAGES = 'transaction_process_packages',
    TRANSACTION_CANCEL_PACKAGES = 'transaction_cancel_packages',
    TRANSACTION_ACKNOWLEDGE_PROCESSING = 'transaction_acknowledge_processing',
    TRANSACTION_ACKNOWLEDGE_PROCESSED = 'transaction_acknowledge_processed',
    TRANSACTION_ACKNOWLEDGE_PROCESSED_WITH_FAILURES = 'transaction_acknowledge_processed_with_failures',
    TRANSACTION_ACKNOWLEDGE_CANCELLED = 'transaction_acknowledge_cancelled',
    TRANSACTION_ACKNOWLEDGE_FAILED = 'transaction_acknowledge_failed',
    TRANSACTION_ANNOUNCE = 'transaction_announce',
    TRANSACTION_MOVE_SPOT = 'transaction_move_spot',
    TRANSACTION_NOTIFY_SENDER = 'transaction_notify_sender',
    TRANSACTION_NOTIFY_RECEIVER = 'transaction_notify_receiver',
    TRANSACTION_NOTIFY_BACKUP_RECEIVER = 'transaction_notify_backup_receiver',
    TRANSACTION_CREATE_PIN_CODE = 'transaction_create_pin_code',
    TRANSACTION_SET_PIN_CODE = 'transaction_set_pin_code',
    TRANSACTION_RETIRE_PIN_CODE = 'transaction_retire_pin_code',
    TRANSACTION_RETURN_EQUIPMENT = 'transaction_return_equipment',
    TRANSACTION_TRANSFER_EQUIPMENT = 'transaction_transfer_equipment',
    TRANSACTION_WITHDRAW_EQUIPMENT = 'transaction_withdraw_equipment',
    TRANSACTION_GRANT_ACCESS = 'transaction_grant_access',
    TRANSACTION_DENY_ACCESS = 'transaction_deny_access',
    TRANSACTION_VERIFY_COURIER_EVENT = 'transaction_verify_courier_event',
    TRANSACTION_DROP_OFF_PACKAGES = 'transaction_drop_off_packages',
    TRANSACTION_PICK_UP_PACKAGES = 'transaction_pick_up_packages',
    TRANSACTION_INFORM_IOT_PROCESSING = 'transaction_inform_iot_processing',
    TRANSACTION_INFORM_IOT_PROCESSED = 'transaction_inform_iot_processed',
    TRANSACTION_INFORM_IOT_PROCESSED_WITH_FAILURES = 'transaction_inform_iot_processed_with_failures',
    TRANSACTION_INFORM_IOT_CANCELLED = 'transaction_inform_iot_cancelled',
    TRANSACTION_INFORM_IOT_FAILED = 'transaction_inform_iot_failed',
    TRANSACTION_INFORM_IOT_IDENTIFIED = 'transaction_inform_iot_identified',
    SHOW_WIZARD = 'show_wizard'
}

export class TransactionAction {
    static readonly TRANSACTION_CHANGE_STATE = new TransactionAction(
        TransactionActionName.TRANSACTION_CHANGE_STATE,
        (
            <FormattedMessage
                id='TransactionAction.change_state'
                description='The displayed value for the TransactionAction change_state'
                defaultMessage='Change state'
            />
        )
    );

    static readonly TRANSACTION_PROCESS_PACKAGES = new TransactionAction(
        TransactionActionName.TRANSACTION_PROCESS_PACKAGES,
        (
            <FormattedMessage
                id='TransactionAction.process_packages'
                description='The displayed value for the TransactionAction process_packages'
                defaultMessage='Process packages'
            />
        )
    );

    static readonly TRANSACTION_CANCEL_PACKAGES = new TransactionAction(
        TransactionActionName.TRANSACTION_CANCEL_PACKAGES,
        (
            <FormattedMessage
                id='TransactionAction.cancel_packages'
                description='The displayed value for the TransactionAction cancel_packages'
                defaultMessage='Cancel packages'
            />
        )
    );

    static readonly TRANSACTION_ACKNOWLEDGE_PROCESSING = new TransactionAction(
        TransactionActionName.TRANSACTION_ACKNOWLEDGE_PROCESSING,
        (
            <FormattedMessage
                id='TransactionAction.acknowledge_processing'
                description='The displayed value for the TransactionAction acknowledge_processing'
                defaultMessage='Acknowledge processing'
            />
        )
    );

    static readonly TRANSACTION_ACKNOWLEDGE_PROCESSED = new TransactionAction(
        TransactionActionName.TRANSACTION_ACKNOWLEDGE_PROCESSED,
        (
            <FormattedMessage
                id='TransactionAction.acknowledge_processed'
                description='The displayed value for the TransactionAction acknowledge_processed'
                defaultMessage='Acknowledge processed'
            />
        )
    );

    static readonly TRANSACTION_ACKNOWLEDGE_PROCESSED_WITH_FAILURES = new TransactionAction(
        TransactionActionName.TRANSACTION_ACKNOWLEDGE_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='TransactionAction.acknowledge_processed_with_failures'
                description='The displayed value for the TransactionAction acknowledge_processed_with_failures'
                defaultMessage='Acknowledge processed with failures'
            />
        )
    );

    static readonly TRANSACTION_ACKNOWLEDGE_CANCELLED = new TransactionAction(
        TransactionActionName.TRANSACTION_ACKNOWLEDGE_CANCELLED,
        (
            <FormattedMessage
                id='TransactionAction.acknowledge_cancelled'
                description='The displayed value for the TransactionAction acknowledge_cancelled'
                defaultMessage='Acknowledge cancelled'
            />
        )
    );

    static readonly TRANSACTION_ACKNOWLEDGE_FAILED = new TransactionAction(
        TransactionActionName.TRANSACTION_ACKNOWLEDGE_FAILED,
        (
            <FormattedMessage
                id='TransactionAction.acknowledge_failed'
                description='The displayed value for the TransactionAction acknowledge_failed'
                defaultMessage='Acknowledge failed'
            />
        )
    );

    static readonly TRANSACTION_ANNOUNCE = new TransactionAction(
        TransactionActionName.TRANSACTION_ANNOUNCE,
        (
            <FormattedMessage
                id='TransactionAction.announce'
                description='The displayed value for the TransactionAction announce'
                defaultMessage='Announce'
            />
        )
    );

    static readonly TRANSACTION_MOVE_SPOT = new TransactionAction(
        TransactionActionName.TRANSACTION_MOVE_SPOT,
        (
            <FormattedMessage
                id='TransactionAction.move_spot'
                description='The displayed value for the TransactionAction move_spot'
                defaultMessage='Move SPOT'
            />
        )
    );

    static readonly TRANSACTION_NOTIFY_SENDER = new TransactionAction(
        TransactionActionName.TRANSACTION_NOTIFY_SENDER,
        (
            <FormattedMessage
                id='TransactionAction.notify_sender'
                description='The displayed value for the TransactionAction notify_sender'
                defaultMessage='Notify sender'
            />
        )
    );

    static readonly TRANSACTION_NOTIFY_RECEIVER = new TransactionAction(
        TransactionActionName.TRANSACTION_NOTIFY_RECEIVER,
        (
            <FormattedMessage
                id='TransactionAction.notify_receiver'
                description='The displayed value for the TransactionAction notify_receiver'
                defaultMessage='Notify receiver'
            />
        )
    );

    static readonly TRANSACTION_NOTIFY_BACKUP_RECEIVER = new TransactionAction(
        TransactionActionName.TRANSACTION_NOTIFY_BACKUP_RECEIVER,
        (
            <FormattedMessage
                id='TransactionAction.notify_backup_receiver'
                description='The displayed value for the TransactionAction notify_backup_receiver'
                defaultMessage='Notify backup receiver'
            />
        )
    );

    static readonly TRANSACTION_CREATE_PIN_CODE = new TransactionAction(
        TransactionActionName.TRANSACTION_CREATE_PIN_CODE,
        (
            <FormattedMessage
                id='TransactionAction.create_pin_code'
                description='The displayed value for the TransactionAction create_pin_code'
                defaultMessage='Create PIN-code'
            />
        )
    );

    static readonly TRANSACTION_SET_PIN_CODE = new TransactionAction(
        TransactionActionName.TRANSACTION_SET_PIN_CODE,
        (
            <FormattedMessage
                id='TransactionAction.set_pin_code'
                description='The displayed value for the TransactionAction set_pin_code'
                defaultMessage='Set PIN-code'
            />
        )
    );

    static readonly TRANSACTION_RETIRE_PIN_CODE = new TransactionAction(
        TransactionActionName.TRANSACTION_RETIRE_PIN_CODE,
        (
            <FormattedMessage
                id='TransactionAction.retire_pin_code'
                description='The displayed value for the TransactionAction retire_pin_code'
                defaultMessage='Retire PIN-code'
            />
        )
    );

    static readonly TRANSACTION_RETURN_EQUIPMENT = new TransactionAction(
        TransactionActionName.TRANSACTION_RETURN_EQUIPMENT,
        (
            <FormattedMessage
                id='TransactionAction.return_equipment'
                description='The displayed value for the TransactionAction return_equipment'
                defaultMessage='Return equipment'
            />
        )
    );

    static readonly TRANSACTION_TRANSFER_EQUIPMENT = new TransactionAction(
        TransactionActionName.TRANSACTION_TRANSFER_EQUIPMENT,
        (
            <FormattedMessage
                id='TransactionAction.transfer_equipment'
                description='The displayed value for the TransactionAction transfer_equipment'
                defaultMessage='Transfer equipment'
            />
        )
    );

    static readonly TRANSACTION_WITHDRAW_EQUIPMENT = new TransactionAction(
        TransactionActionName.TRANSACTION_WITHDRAW_EQUIPMENT,
        (
            <FormattedMessage
                id='TransactionAction.withdraw_equipment'
                description='The displayed value for the TransactionAction withdraw_equipment'
                defaultMessage='Withdraw equipment'
            />
        )
    );

    static readonly TRANSACTION_GRANT_ACCESS = new TransactionAction(
        TransactionActionName.TRANSACTION_GRANT_ACCESS,
        (
            <FormattedMessage
                id='TransactionAction.grant_access'
                description='The displayed value for the TransactionAction grant_access'
                defaultMessage='Grant access'
            />
        )
    );

    static readonly TRANSACTION_DENY_ACCESS = new TransactionAction(
        TransactionActionName.TRANSACTION_DENY_ACCESS,
        (
            <FormattedMessage
                id='TransactionAction.deny_access'
                description='The displayed value for the TransactionAction deny_access'
                defaultMessage='Deny access'
            />
        )
    );

    static readonly TRANSACTION_VERIFY_COURIER_EVENT = new TransactionAction(
        TransactionActionName.TRANSACTION_VERIFY_COURIER_EVENT,
        (
            <FormattedMessage
                id='TransactionAction.verify_courier_event'
                description='The displayed value for the TransactionAction verify_courier_event'
                defaultMessage='Verify courier event'
            />
        )
    );

    static readonly TRANSACTION_DROP_OFF_PACKAGES = new TransactionAction(
        TransactionActionName.TRANSACTION_DROP_OFF_PACKAGES,
        (
            <FormattedMessage
                id='TransactionAction.drop_off_packages'
                description='The displayed value for the TransactionAction drop_off_packages'
                defaultMessage='Drop off packages'
            />
        )
    );

    static readonly TRANSACTION_PICK_UP_PACKAGES = new TransactionAction(
        TransactionActionName.TRANSACTION_PICK_UP_PACKAGES,
        (
            <FormattedMessage
                id='TransactionAction.pick_up_packages'
                description='The displayed value for the TransactionAction pick_up_packages'
                defaultMessage='Pick up packages'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_PROCESSING = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSING,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_processing'
                description='The displayed value for the TransactionAction inform_iot_processing'
                defaultMessage='Inform IoT processing'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_PROCESSED = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSED,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_processed'
                description='The displayed value for the TransactionAction inform_iot_processed'
                defaultMessage='Inform IoT processed'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_PROCESSED_WITH_FAILURES = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_PROCESSED_WITH_FAILURES,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_processed_with_failures'
                description='The displayed value for the TransactionAction inform_iot_processed_with_failures'
                defaultMessage='Inform IoT processed with failures'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_CANCELLED = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_CANCELLED,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_cancelled'
                description='The displayed value for the TransactionAction inform_iot_cancelled'
                defaultMessage='Inform IoT cancelled'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_FAILED = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_FAILED,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_failed'
                description='The displayed value for the TransactionAction inform_iot_failed'
                defaultMessage='Inform IoT failed'
            />
        )
    );

    static readonly TRANSACTION_INFORM_IOT_IDENTIFIED = new TransactionAction(
        TransactionActionName.TRANSACTION_INFORM_IOT_IDENTIFIED,
        (
            <FormattedMessage
                id='TransactionAction.inform_iot_identified'
                description='The displayed value for the TransactionAction inform_iot_identified'
                defaultMessage='Inform IoT identified'
            />
        )
    );

    static readonly ALL = [
        TransactionAction.TRANSACTION_CHANGE_STATE,
        TransactionAction.TRANSACTION_PROCESS_PACKAGES,
        TransactionAction.TRANSACTION_CANCEL_PACKAGES,
        TransactionAction.TRANSACTION_ACKNOWLEDGE_PROCESSING,
        TransactionAction.TRANSACTION_ACKNOWLEDGE_PROCESSED,
        TransactionAction.TRANSACTION_ACKNOWLEDGE_PROCESSED_WITH_FAILURES,
        TransactionAction.TRANSACTION_ACKNOWLEDGE_CANCELLED,
        TransactionAction.TRANSACTION_ACKNOWLEDGE_FAILED,
        TransactionAction.TRANSACTION_ANNOUNCE,
        TransactionAction.TRANSACTION_MOVE_SPOT,
        TransactionAction.TRANSACTION_NOTIFY_SENDER,
        TransactionAction.TRANSACTION_NOTIFY_RECEIVER,
        TransactionAction.TRANSACTION_NOTIFY_BACKUP_RECEIVER,
        TransactionAction.TRANSACTION_CREATE_PIN_CODE,
        TransactionAction.TRANSACTION_SET_PIN_CODE,
        TransactionAction.TRANSACTION_RETIRE_PIN_CODE,
        TransactionAction.TRANSACTION_RETURN_EQUIPMENT,
        TransactionAction.TRANSACTION_TRANSFER_EQUIPMENT,
        TransactionAction.TRANSACTION_WITHDRAW_EQUIPMENT,
        TransactionAction.TRANSACTION_GRANT_ACCESS,
        TransactionAction.TRANSACTION_DENY_ACCESS,
        TransactionAction.TRANSACTION_VERIFY_COURIER_EVENT,
        TransactionAction.TRANSACTION_DROP_OFF_PACKAGES,
        TransactionAction.TRANSACTION_PICK_UP_PACKAGES,
        TransactionAction.TRANSACTION_INFORM_IOT_PROCESSING,
        TransactionAction.TRANSACTION_INFORM_IOT_PROCESSED,
        TransactionAction.TRANSACTION_INFORM_IOT_PROCESSED_WITH_FAILURES,
        TransactionAction.TRANSACTION_INFORM_IOT_CANCELLED,
        TransactionAction.TRANSACTION_INFORM_IOT_FAILED,
        TransactionAction.TRANSACTION_INFORM_IOT_IDENTIFIED
    ];
    private constructor(
        public readonly value: TransactionActionName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(value: TransactionActionName): TransactionAction | undefined {
        return TransactionAction.ALL.find((action) => action.value === value);
    }
}
